<template>
  <div class="select-model">
    <el-dialog
      title="选择翻译引擎"
      :visible.sync="selectModeVisible"
      width="700px"
      class="mode-dialog"
      :modal-append-to-body="false"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="神经网络翻译（通用领域）" name="first">
          <div class="list-header">
            <div
              class="item"
              :style="{ width: item.width }"
              v-for="item in columns"
              :key="item.value"
            >
              {{ item.label }}
            </div>
          </div>
          <el-scrollbar class="scrollbar">
            <div
              class="list-item"
              v-for="(data, index) in domainOptionsGeneral"
              :key="data.index"
            >
              <div
                class="item"
                :style="{ width: item.width }"
                v-for="item in columns"
              >
                <i
                  v-if="item.value === 'use'"
                  class="data-checkbox"
                  :data-track-text="`选择领域${data.label}`"
                  :aria-label="`选择领域${data.label}`"
                  :class="[
                    currentDomain.label === data.label
                      ? 'el-icon-check active'
                      : '',
                  ]"
                  @click.stop="changeDomain(data)"
                ></i>
                <span v-else-if="item.value === 'index'" class="data-value">
                  {{ index + 1 }}
                </span>
                <span v-else class="data-value">{{ data[item.value] }}</span>
              </div>
            </div>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane label="神经网络翻译（垂直领域）" name="second">
          <div class="list-header">
            <div
              class="item"
              :style="{ width: item.width }"
              v-for="item in columns"
              :key="item.value"
            >
              {{ item.label }}
            </div>
          </div>
          <el-scrollbar class="scrollbar">
            <div
              class="list-item"
              v-for="(data, index) in domainOptions"
              :key="data.index"
            >
              <div
                class="item"
                :style="{ width: item.width }"
                v-for="item in columns"
              >
                <i
                  v-if="item.value === 'use'"
                  class="data-checkbox"
                  :data-track-text="`选择领域${data.label}`"
                  :aria-label="`选择领域${data.label}`"
                  :class="[
                    currentDomain.label === data.label
                      ? 'el-icon-check active'
                      : '',
                  ]"
                  @click.stop="changeDomain(data)"
                ></i>
                <span v-else-if="item.value === 'index'" class="data-value">
                  {{ index + 1 }}
                </span>
                <span v-else class="data-value">{{ data[item.value] }}</span>
              </div>
            </div>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane
          label=""
          :class="[!modelChange ? 'disabled' : '']"
          name="third"
          :disabled="!modelChange"
        >
          <span slot="label" class="third-title">
            大语言模型翻译
	            <span v-if="!modelChange" class="buy" data-track-text="开通模型套餐" aria-label="开通模型套餐" @click="gotoPay">
              开通套餐
            </span>
          </span>
          <div class="list-header">
            <div
              class="item"
              :style="{ width: item.width }"
              v-for="item in columns"
              :key="item.value"
            >
              {{ item.label }}
            </div>
          </div>
          <el-scrollbar class="scrollbar">
            <div
              class="list-item"
              v-for="(data, index) in aiModels"
              :key="data.index"
            >
              <div
                class="item"
                :style="{ width: item.width }"
                v-for="item in columns"
              >
                <i
                  v-if="item.value === 'use'"
                  class="data-checkbox"
                  :data-track-text="`选择AI模型${data.label}`"
                  :aria-label="`选择AI模型${data.label}`"
                  :class="[
                    currentAiMode.label === data.label
                      ? 'el-icon-check active'
                      : '',
                  ]"
                  @click.stop="changeAiMode(data)"
                ></i>
                <span v-else-if="item.value === 'index'" class="data-value">
                  {{ index + 1 }}
                </span>
                <span v-else class="data-value">{{ data[item.value] }}</span>
              </div>
            </div>
          </el-scrollbar>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
	        <span class="btn-item primary" data-track-text="确认翻译模型" aria-label="确认翻译模型" @click="selectAiMode"> 确定 </span>
	        <span class="btn-item" data-track-text="取消翻译模型选择" aria-label="取消翻译模型选择" @click="hideSelectMode"> 取消 </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  // 组件名称
  name: "SelectModel",
  props: {
    // 传入的类型
    showLangV: {
      type: Number,
      default: 0,
    },
    aiModelList: {
      type: Array,
      default: () => [],
    },
    domainOptionsAll: {
      type: Array,
      default: () => [],
    },
  },
  // 变量声明
  data() {
    return {
      nameStr: "大模型选择",
      aiMode: {},
      selectModeVisible: false,
      activeName: "first",
      currentAiMode: {},
      currentDomain: {},
      domainOptionsGeneral: [
        {
          index: 1,
          use: 0,
          value: "",
          label: "混合模型",
          from: "支持200多种互译",
        },
      ],
      domainOptions: [
        {
          index: 1,
          use: 0,
          value: "it",
          label: "信息技术",
          from: "中英互译",
        },
        {
          index: 2,
          use: 0,
          value: "finance",
          label: "金融财经",
          from: "中英互译",
        },
        {
          index: 3,
          use: 0,
          value: "machinery",
          label: "机械制造",
          from: "中英互译",
        },
        {
          index: 4,
          use: 0,
          value: "senimed",
          label: "生物医药",
          from: "中英互译",
        },
        {
          index: 5,
          use: 0,
          value: "novel",
          label: "网络文学",
          from: "(中-英)",
        },
        {
          index: 6,
          use: 0,
          value: "academic",
          label: "学术论文",
          from: "中英互译",
        },
        {
          index: 7,
          use: 0,
          value: "aerospace",
          label: "航空航天",
          from: "中英互译",
        },
        {
          index: 8,
          use: 0,
          value: "wiki",
          label: "人文社科",
          from: "(中-英)",
        },
        {
          index: 9,
          use: 0,
          value: "news",
          label: "新闻资讯",
          from: "中英互译",
        },
        {
          index: 10,
          use: 0,
          value: "law",
          label: "法律法规",
          from: "中英互译",
        },
        {
          index: 11,
          use: 0,
          value: "contract",
          label: "合同领域",
          from: "中英互译",
        },
      ],
      columns: [
        {
          label: "序号",
          value: "index",
          width: "100px",
        },
        {
          label: "启用",
          value: "use",
          width: "100px",
        },
        {
          label: "翻译模型",
          value: "label",
          width: "300px",
        },
        {
          label: "支持语种",
          value: "from",
          width: "300px",
        },
      ],
      modelChange: false,
      rowData: {},
    };
  },
  watch: {
    aiModelList() {
      this.aiMode =
        this.aiModelList?.find((item) => item.model === "SPARK") || {};
    },
  },
  computed: {
    aiModels() {
      const supportedModels = ["ChatGPT", "DeepSeek", "WENXIN", "QIANWEN", "SPARK", "ChatGLM", "Doubao", "QIANFAN"];
      return this.aiModelList?.filter((item) => supportedModels.includes(item.model)).map((item, index) => {
        return {
          ...item,
          index: index + 1,
          label: item.name,
          use: 0,
          from: "中英互译",
        };
      });
    },
  },
  // 实例初始化之后,进行数据侦听和事件/侦听器的配置之前同步调用
  beforeCreate() {},
  // 实例创建，挂载阶段未开始，可进行数据初始化
  created() {},
  mounted() {},
  // 方法
  methods: {
    gotoPay() {
      window.open("https://user.wesitrans.com/meal", "_blank");
    },
    showSelectMode(item) {
      this.$http.get("/chatApi/app/user/power").then((res) => {
        this.modelChange = !!res.data.data?.modelChange;
      });
      this.selectModeVisible = true;
      this.currentAiMode =
        this.aiModels.find((model) => model.value === item.model) || {};
      this.currentDomain =
        [...this.domainOptionsGeneral, ...this.domainOptions].find(
          (domain) => domain.value === item.model
        ) || {};
      this.rowData = item;
      console.log(33, this.aiModels);
      console.log(44, this.domainOptionsGeneral);
      console.log(55, this.domainOptions);
    },
    hideSelectMode() {
      this.selectModeVisible = false;
    },
    changeDomain(item) {
      this.currentDomain = item;
      this.currentAiMode = {};
    },
    changeAiMode(item) {
      this.currentAiMode = item;
      this.currentDomain = {};
    },
    selectAiMode() {
      this.nameStr = this.currentDomain.label || this.currentAiMode.label;
      this.$emit(
        "selectModel",
        this.currentDomain,
        this.currentAiMode,
        this.rowData
      );
      this.hideSelectMode();
    },
  },
};
</script>

<style lang="less" scoped>
.select-model {
  .select-mode {
    background-color: var(--primary);
    border-color: var(--primary);
    height: 40px;
    border-radius: 8px;
  }
  .mode-dialog {
    /deep/.el-dialog__header {
      font-weight: bold;
    }
    /deep/.el-dialog__body {
      padding: 0px 20px;
    }
    /deep/.el-tabs__item {
      font-size: 16px;
      height: 50px;
      line-height: 56px;
      &.is-active {
        color: var(--primary);
        font-weight: bold;
      }
      &:not(.is-disabled) {
        &:hover {
          color: var(--primary);
        }
      }
    }
    /deep/.el-tabs__active-bar {
      background-color: var(--primary);
    }
    .third-title {
      position: relative;
      .buy {
        color: #fff;
        font-size: 12px;
        background: #f7b52c;
        padding: 2px 4px;
        border-radius: 10px 0 10px 0;
        position: absolute;
        right: -40px;
        top: -16px;
        line-height: 16px;
        cursor: pointer;
      }
    }

    .list-header {
      display: flex;
      background: #f3f5f8;
      .item {
        font-weight: bold;
        font-size: 14px;
        color: #737373;
        line-height: 48px;
        text-align: center;
      }
    }
    .scrollbar {
      height: 300px;
      /deep/.el-scrollbar__wrap {
        overflow-x: hidden;
      }
    }
    .list-item {
      display: flex;
      .item {
        font-size: 14px;
        color: #666666;
        line-height: 38px;
        text-align: center;
        .data-checkbox {
          display: inline-block;
          width: 18px;
          height: 18px;
          cursor: pointer;
          background: #ffffff;
          border: 1px solid #d5e0e4;
          border-radius: 50%;
          color: #fff;
          line-height: 18px;
          font-size: 12px;
          vertical-align: middle;
          &.active {
            background: var(--primary);
          }
        }
      }
    }
    .dialog-footer {
      text-align: center;
      margin-bottom: 30px;
      .btn-item {
        padding: 10px 28px;
        font-size: 16px;
        line-height: 24px;
        box-shadow: 0px 5px 20px 0px rgba(62, 109, 119, 0.3);
        border-radius: 6px;
        cursor: pointer;
      }
      .primary {
        margin-right: 48px;
        background: var(--primary);
        color: #ffffff;
      }
    }
  }
}
</style>

<!-- <style lang="less" scoped src="../../assets/v2/css/trans/common.less"/>
<style lang="less" scoped src="../../assets/v2/css/trans/index.less"/> -->
